import {observable, computed, action, autorun} from 'mobx';


export class LoginForm {
  @observable dirtyValues = {
    userName: undefined,
    password: undefined,
  }

  @computed get values() {
    return this.dirtyValues;
  }

  @action.bound reset(values) {
    for(let k in values) {
      this.dirtyValues[k] = values[k];
    }
  }

  constructor() {
  }
}


// WEBPACK FOOTER //
// ./src/view/LoginForm.js